<template>
  <svg viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg">
    <title>Right keyboard arrow icon</title>
    <path
      d="M0.590088 10.59L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.59Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'KIconKeyboardArrowRight'
}
</script>
